var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notificator"},_vm._l((_vm.notifications),function(notification,key){return _c('div',{key:key,staticClass:"notification",class:notification.level,on:{"click":function($event){return _vm.click($event, key)}}},[_vm._v(_vm._s(notification.text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }